import React from 'react';

/** Employee complaint tracking — opens tracking status popup. */
export function TrackingStatusButton({ onClick, className = '' }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`group inline-flex shrink-0 items-center gap-1 rounded-full bg-brand px-3 py-1 text-xs font-semibold text-white ${className}`}
      aria-label="View complaint tracking status"
    >
      <span className="flex h-4 w-4 items-center justify-center rounded-full bg-white/15">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-3.5 w-3.5"
          aria-hidden
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M12 6v6l4 2" />
        </svg>
      </span>
      <span>Track Status</span>
    </button>
  );
}

export default TrackingStatusButton;
